import { BASE_URL } from "../config";
import api from "../axiosConfig";   // ✅ This was missing

export const fetchStockistData = async (employeeId) => {
    const response = await fetch(
      `${BASE_URL}/api/stockist/sms-data?employee_id=${employeeId}`
    );
    if (!response.ok) throw new Error('Failed to fetch stockist data');
    return response.json();
  };
  
  export const fetchMessageStatus = async (employeeId, stockistId, date) => {
    const response = await fetch(
      `${BASE_URL}/api/get_stockist_message_status?employee_id=${employeeId}&stockist_id=${stockistId}&date=${date}`
    );
    if (!response.ok) throw new Error('Failed to fetch message status');
    return response.json();
  };
  
  export const sendStockistMessage = async (messageData) => {
    const response = await fetch(
      `${BASE_URL}/api/send_stockist_pob_message`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(messageData)
      }
    );
    if (!response.ok) throw new Error('Failed to send message');
    return response.json();
  };


export const fetchStates = async () => {
  try {
    const response = await api.get("/api/states");
    return response.data || [];
  } catch (error) {
    console.error("Error fetching states:", error);
    throw error;
  }
};


export const fetchEmployees = async (stateId) => {
  try {
    const response = await api.get(`/api/employees?state_id=${stateId}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

export const loadScheme = async(stateId) => {
   if (!stateId) return;
  try{
const response = await api.get(`/api/scheme`);
return response.data || [];
  }
  catch(error){
 console.error("Failed to load schemes:", error);
  }
}

export const fetchDivisions = async () => {
  try {
    const response = await api.get(`/api/divisions`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching divisions:", error);
    throw error;
  }
};

export const fetchEmployeeMonthlySchemeReport = async ({
  state_id,
  year,
  month,
  division,
  employee_id,
  scheme_id,
}) => {
  try {
    const params = new URLSearchParams({
      state_id,
      year,
      month,
      division,
      division,
      employee_id,
      scheme_id,
    });

    const response = await api.get(`/api/reports/employee-monthly-scheme?${params.toString()}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};


export const fetchEmployeeChemistSchemeReport = async ({
  state_id,
  year,
  month,
  division,
  employee_id,
  scheme_id,
}) => {
  try {
    const params = new URLSearchParams({
      state_id,
      year,
      month,
      division,
      employee_id,
      scheme_id,
    });


    const response = await api.get(`/api/reports/employee-chemist-scheme-visits?${params.toString()}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};


export const updateQuantity = async (payload) => {
  try {
    const response = await api.post(`/api/visits/update-visit-product-quantity/`, payload);
    return response.data || [];
  } catch (error) {
    console.error("Error updating quantity:", error);
    throw error;
  }
};

export const fetchRoles = async () => {
try{
  const response = await api.get(`/api/role`);
  return response.data || [];
}
catch(error){
  console.error("Error fetching roles:", error);
  throw error;
}
}


export const updateEmployeeRole = async (employeeId, newRole) => {
  try {
    const params = new URLSearchParams({
      new_role: newRole,
    });

    const response = await api.put(`/api/employees/${employeeId}/update-role?${params.toString()}`);
    return response.data || [];
  } catch (error) {
    console.error("Error updating employee role:", error);
    throw error;
  }
};



export const fetchChemistData = async ({ 
  stateId, 
  employeeId, 
  sortBy = "area", 
  retailerType = "chemist" 
}) => {
  try {
    const params = new URLSearchParams({
      state_id: stateId,
      employee_id: employeeId,
      sort_by: sortBy,
      retailer_type: retailerType,
    });

    const response = await api.get(`/api/chemist/chemists/filter?${params.toString()}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching chemist data:", error);
    throw error;
  }
};
